import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { scenarios } from '@/mocks/smart-farm';

export default function Scenarios() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="应用场景"
          title="面向多元农业经营场景"
          subtitle="覆盖粮食、设施、经作及组织化经营等多种农业形态，适配不同主体的数字化需求。"
        />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {scenarios.map((scene) => (
              <a
                key={scene.id}
                href="#consultation"
                className="group relative rounded-lg overflow-hidden border border-background-200 cursor-pointer"
              >
                <div className="w-full h-56 overflow-hidden">
                  <img
                    src={scene.image}
                    alt={scene.title}
                    title={`${scene.title}场景`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-heading font-bold text-background-50 text-xl">{scene.title}</h3>
                  <p className="mt-1.5 text-sm text-background-200 leading-relaxed">{scene.desc}</p>
                </div>
                <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 backdrop-blur border border-background-50/20 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-up-line"></i>
                </div>
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}